import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-fit" }
const _hoisted_2 = { class: "flex items-start" }
const _hoisted_3 = { class: "pt-3 pr-10" }
const _hoisted_4 = { class: "flex items-center justify-center w-full" }

import { Cog6ToothIcon, LockClosedIcon, XCircleIcon } from '@heroicons/vue/24/solid'
import { useStore } from 'vuex';
import { type Component,  ref, shallowRef } from 'vue';
import Tuning from './tabs/Tuning/index.vue'
import Header from './tabs/Header/index.vue'
import Advanced from './tabs/Advanced/index.vue'
import { useDoc } from '@/composables/useDoc';



export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const tabs: { title: string, component: Component, key: number }[] = [
    { title: 'Tuning', component: Tuning, key: 0 },
    { title: 'Header', component: Header, key: 1 },
    { title: 'Advanced', component: Advanced, key: 2 },

]

const maxHeight = ref('10px')
const currentTab = shallowRef(tabs[1]);
const currentTabVModel = ref(currentTab.value.key)
const store = useStore();
const escListener = (e: KeyboardEvent) => {
    if (e.key == 'Escape') store.state.ui.showPreferencesModal = false
}


async function saveAndClose() {
    store.state.ui.showPreferencesModal = false
    await useDoc().save();
}

return (_ctx: any,_cache: any) => {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_VaModal = _resolveComponent("VaModal")!

  return (_openBlock(), _createBlock(_component_VaModal, {
    modelValue: _unref(store).state.ui.showPreferencesModal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(store).state.ui.showPreferencesModal) = $event)),
    backgroundColor: "info",
    size: "large",
    cancelText: " ",
    gradient: "",
    fixedLayout: "",
    hideDefaultActions: ""
  }, {
    anchor: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).state.ui.showPreferencesModal = true)),
          class: "cursor-pointer"
        }, [
          _createVNode(_unref(Cog6ToothIcon), { class: "w-8 fill-white" })
        ])
      ])
    ]),
    header: _withCtx(() => [...(_cache[3] || (_cache[3] = [
      _createElementVNode("strong", null, " Document Preferences ", -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_va_tabs, {
            vertical: "",
            grow: "",
            modelValue: currentTabVModel.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTabVModel).value = $event)),
            color: "white"
          }, {
            tabs: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
                return _createVNode(_component_va_tab, {
                  key: tab.key,
                  color: "white",
                  onClick: () => currentTab.value = tab,
                  name: tab.key
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tab.title), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "name"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(currentTab.value.component), {
            key: _unref(store).state.utils.keyCoefficient
          }))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_va_button, {
        onClick: saveAndClose,
        color: "success"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("Save", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})